let lastScrollY = window.scrollY;

//Side Cart Button
let main  = document.querySelector("main");
let openCart = document.querySelectorAll(".cart-btn");

openCart.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();

    document.querySelector("#top-search").classList.remove("active");
    document.querySelector("#top-search").classList.remove("animate-lg");
    document.querySelector(".mobile-nav").classList.remove("active");
    document.querySelector(".mobile-nav").classList.remove("animate-lg");
    let menuBtn = document.querySelectorAll(".menu-btn");
    menuBtn.forEach((btn) => {
      btn.classList.remove("close");
    });
    document.querySelector("header").classList.remove("is-active");

    
    document.querySelector("#side-cart").classList.toggle("animate-lg");
    document.querySelector("#side-cart").classList.toggle("active");
  });
});

//Close Side Cart Button
let closeCart = document.querySelectorAll(".close-cart-btn");

closeCart.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    let cart = document.querySelector("#side-cart");
    cart.classList.remove("active");
  });
});

let menuBtn = document.querySelectorAll(".menu-btn");

menuBtn.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    document.querySelector("#top-search").classList.remove("active");
    document.querySelector("#top-search").classList.remove("animate-lg");
    document.querySelector("#side-cart").classList.remove("active");
    document.querySelector("#side-cart").classList.remove("animate-lg");

    btn.classList.toggle("close");
    //document.querySelector("main").classList.toggle("hide");
    //document.querySelector("header").classList.toggle("is-active");
    document.querySelector(".mobile-nav").classList.toggle("animate-lg");
    document.querySelector(".mobile-nav").classList.toggle("active");
  });
});

let searchBtn = document.querySelectorAll(".search-btn");

searchBtn.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    document.querySelector("#side-cart").classList.remove("active");
    document.querySelector("#side-cart").classList.remove("animate-lg");
    document.querySelector(".mobile-nav").classList.remove("active");
    document.querySelector(".mobile-nav").classList.remove("animate-lg");
    document.querySelector("header").classList.remove("is-active");
    let menuBtn = document.querySelectorAll(".menu-btn");
    menuBtn.forEach((btn) => {
      btn.classList.remove("close");
    });

    document.querySelector("main").classList.toggle("hide");
    document.querySelector("#top-search").classList.toggle("animate-lg");
    document.querySelector("#top-search").classList.toggle("active");
    document.querySelector("#search-form").focus();
  });
});

//Menu Dropdown
let navChild = document.querySelectorAll(".has-child");

navChild.forEach((child) => {
  child.addEventListener("click", (event) => {
    event.preventDefault();
    child.classList.toggle("active");
  });
});

let desktopSearchBtn = document.querySelector(".desktop-search-btn");

desktopSearchBtn.addEventListener("click", (event) => {
  event.preventDefault();
  document.querySelector("#desktop-search-input").focus();
});

//Newsletter
let newsletterFormWrap = document.querySelectorAll('.newsletter-form-wrap');

if (newsletterFormWrap.length > 0) {

  newsletterFormWrap.forEach(function (item) {
    let newsletterForm = item.querySelector('form');
    let newsletterEmail = item.querySelector('#newsletter-email');
    let successMessage = item.querySelector('.success');

    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();

      const emailValue = newsletterEmail.value;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailValue,
                  properties: {
                    "website-source": "email-capture"
                  }    
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "VQDrRH",
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=XRLAjE', requestOptions)
        .then((res) => {
          if (res.ok) {
            // Check if there is content to parse
            return res.text().then((text) => (text ? JSON.parse(text) : {}));
          } else {
            return res.json().then((errorDetails) => {
              throw new Error(`Failed to subscribe: ${errorDetails.message}`);
            });
          }
        })
        .then((res) => {
          //console.log('Submission successful:', res);
          newsletterEmail.classList.add('hide');
          successMessage.classList.remove('hide');
        })
        .catch((err) => {
          //console.error('Error occurred:', err);
          //successMessage.classList.add('hide');
        });
    });
  });
}

let newsletterBtn = document.querySelectorAll('.newsletter-btn');

if (newsletterBtn.length > 0) {
  newsletterBtn.forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'XYQL9c']);
    });
  });
}

//Mobile Nav Dropdown
let mobileDropDown = document.querySelectorAll(".mobile-nav .dropdown");

mobileDropDown.forEach((child) => {
  let dropBtn = child.querySelector(".drop-btn");
  dropBtn.addEventListener("click", (event) => {
    event.preventDefault();
    child.classList.toggle("active");
  });
});